import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft, Loader2 } from "lucide-react";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { PoForm } from "@/features/purchase-orders/PoForm";
import { usePurchaseOrder } from "@/features/purchase-orders/api";

export const Route = createFileRoute("/_authenticated/purchase-orders/$poId/edit")({
  component: EditPoPage,
});

function EditPoPage() {
  const navigate = useNavigate();
  const { poId } = Route.useParams();
  const { data: po, isLoading } = usePurchaseOrder(poId);

  useEffect(() => {
    if (po && po.status !== "Draft") {
      navigate({ to: "/purchase-orders/$poId", params: { poId }, replace: true });
    }
  }, [po, poId, navigate]);

  if (isLoading || !po) return <div className="grid place-items-center p-10"><Loader2 className="h-5 w-5 animate-spin" /></div>;

  return (
    <div className="mx-auto max-w-6xl space-y-4">
      <Button variant="ghost" size="sm" onClick={() => navigate({ to: "/purchase-orders/$poId", params: { poId } })}><ArrowLeft className="mr-1 h-4 w-4" />Back</Button>
      <PoForm existing={po} />
    </div>
  );
}
